import React, {Component} from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import {Grid, Button, Popup, Header, Icon} from "semantic-ui-react";
import AdSense from "react-adsense";
import MovingText from "./ScrollingText";
class SignedInAd extends Component {
    render() {
        return(
        <div id="internal-ad-off">
        <Grid columns={16} stackable={false}
              style={{minHeight: 60, paddingTop: 2, backgroundColor: 'rgb(140 189 156)', paddingLeft: 15}}>

            <Grid.Column width={4} key='app_links' >
                <div >
                    <a style={{color: '#ffffff', fontSize: 15}} target="_blank" as='a' href='https://dcaclab.com/pages/classrooms-mangement'>
                        {/*<Icon name='info' />*/}
                        Classrooms
                    </a>
                    <a style={{color: '#ffffff', fontSize: 15, paddingLeft: 10}}  color='orange'  target="_blank" as='a' href='https://dcaclab.com/pages/assignments-management'>
                        {/*<Icon name='info' />*/}
                        Assignment
                    </a>

                    <a style={{color: '#ffffff', fontSize: 15, paddingLeft: 10}} icon='youtube' circular="'true'" color='red'  target="_blank" as='a' href='https://youtube.com/playlist?list=PLzqxk04syoqIbxD2WYsjI8W4ghoiyKbTW'>
                        Tutorials
                    </a>
                </div>
            </Grid.Column>

            {this.props.show_ads &&
                <Grid.Column style={{backgroundColor: 'inherited'}} width={10} key='adsense-internal' textAlign="right">
                    <>
                            <AdSense.Google
                                client='ca-pub-4274068129397983'
                                slot='1035864869'
                                style={{ width: 600, height: 70, float: 'right' }}
                                format=''
                            />
                    </>
                </Grid.Column>
            }
            {this.props.restrict_save &&
            <Grid.Column width={4} key='moving_text' floated='right' >
                <MovingText texts={this.props.texts}/>
            </Grid.Column>
            }

        </Grid>
        </div>
        )
    }
}

export default SignedInAd;
